import axios from "axios";
import { base_url } from "../../../utils/baseUrl";

const getTransports = async () => {
  var authToken = "Transport";
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const response = await axios.get(`${base_url}luxury/getLuxury`,{ headers });
 
  return response.data;
  
};
const createTransports = async (formData) => {
  const response = await axios.post(`${base_url}luxury/register`, formData);

  return response.data;
};
const updateTransport = async (News) => {
  const formData = new FormData();
  formData.append("name", News.NewsData.get("name"));
  formData.append("type", News.NewsData.get("type"));
  formData.append("email", News.NewsData.get("email"));
  formData.append("password", News.NewsData.get("password"));
  formData.append("image", News.NewsData.get("image"));

  const response = await axios.put(
    `${base_url}luxury/editLuxury/${News.id}`,
    formData
  );

  return response.data;
};

const getTransport = async (id) => {
  const response = await axios.get(`${base_url}luxury/getById/${id}`);

  return response.data;
};

const deleteTransport = async (id) => {
  const response = await axios.delete(`${base_url}luxury/deleteLuxury/${id}`);

  return response.data;
};
const TransportService = {
  getTransports,
  createTransports,
  getTransport,
  updateTransport,
  deleteTransport,
};

export default TransportService;
